export default __webpack_public_path__ + "static/media/menu_2_cloud.cd10c40b.jpg";